
import { computed, ComputedRef, defineComponent, onMounted } from "vue";
import { disableBodyOverflow, enableBodyOverflow } from "../../mixins";
import { User } from "../../../../../domain/entities/entities";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();

    const user: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    onMounted(() => {
      disableBodyOverflow();
    });

    const closeModal = async (): Promise<void> => {
      await store.dispatch("decoins_module/setDecoinsLimitModal", false);
      enableBodyOverflow();
      await store.dispatch("decoins_module/decoinDailyLimitMessageAccepted");
    };

    return {
      user,
      closeModal
    };
  }
});
